import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import Slider from "react-slick";
import "./HeroSection.css";
import PopupForm from "../PopUp";
import { baseURl } from "../../config";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { useSelector } from "react-redux";

// Custom Arrows
const NextArrow = ({ onClick }) => (
  <div className="custom-arrow custom-next" onClick={onClick}>
    <FaChevronRight />
  </div>
);

const PrevArrow = ({ onClick }) => (
  <div className="custom-arrow custom-prev" onClick={onClick}>
    <FaChevronLeft />
  </div>
);

const HeroSection = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [data, setData] = useState([]);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const { banners } = useSelector((state) => state.data);

  // Handle window resize to update isMobile state
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    let isMounted = true;
    const fetchData = async () => {
      try {
        const response = banners;
        setData(Array.isArray(response) ? response : []);
      } catch (error) {
        console.error("Error fetching banner data:", error);
      }
    };

    fetchData();
    return () => {
      isMounted = false;
    };
  }, [banners]);

  const handlePopupClose = () => setIsPopupOpen(false);

  const settings = useMemo(
    () => ({
      dots: true,
      infinite: true,
      speed: 1000,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 3000,
      fade: true,
      cssEase: "cubic-bezier(0.86, 0, 0.07, 1)",
      nextArrow: isMobile ? null : <NextArrow />,
      prevArrow: isMobile ? null : <PrevArrow />,
    }),
    [isMobile]
  );

  const sliderContent = useMemo(
    () =>
      data.map((item, index) => {
        const headingText = item?.heading || "Sourcing Excellence, Delivering Quality Metals";
        const subheadingText =
          item?.subheading ||
          "At Akinex, we specialize in connecting businesses with premium-quality metals sourced from trusted suppliers worldwide.";

        return (
          <div key={`hero-${index}`} className="hero-slide">
            {item?.bannerImage && (
              <div
                className="hero-slide-image"
                style={{ backgroundImage: `url("${baseURl}/${item.bannerImage}")` }}
              >
                <div className="overlay"></div>
              </div>
            )}
            <div className="hero-content">
              <h1 className="hero-title fade-in-slide-up">{headingText}</h1>
              <p className="hero-description fade-in-slide-up">{subheadingText}</p>
            </div>
          </div>
        );
      }),
    [data]
  );

  return (
    <section className="hero-section">
      <Slider {...settings}>{sliderContent}</Slider>
      {/* {isPopupOpen && <PopupForm isOpen={isPopupOpen} onClose={handlePopupClose} />} */}
    </section>
  );
};

export default HeroSection;
